export type OverrideReason =
  | 'AI misread evidence'
  | 'Rubric mismatch'
  | 'Borderline case'
  | 'Other';

export const overrideReasons: OverrideReason[] = [
  'AI misread evidence',
  'Rubric mismatch',
  'Borderline case',
  'Other',
];
